function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M512 176c0 42-22 85-65 129L269 476c-4 3-8 5-13 5s-9-2-13-5L65 304c-2-2-4-4-8-7-3-4-8-10-16-19-7-9-13-18-19-28s-11-21-15-35c-5-13-7-26-7-39 0-42 12-75 36-98 24-24 58-36 101-36 11 0 23 2 36 6 12 5 23 10 34 17s20 13 27 20c8 6 15 12 22 19 7-7 14-13 22-19 7-7 16-13 27-20s22-12 34-17c13-4 25-6 36-6 43 0 77 12 101 36 24 23 36 56 36 98z"
}));